<template>
  <div class="home-index">
    <div class="banner">
      <el-carousel :interval="3000" arrow="always" indicator-position="none">
        <el-carousel-item v-for="(item,index) in bannerCon" :key="item.id">
          <div class="index-banner"
               :style="{'backgroundImage': 'url(' + $global.globalPath + item.src + ')'}"
               @click="goBannerLink(item.link,item.i_button)"
          >
            <div class="w1200">
              <div class="banner-contents" :style="{'text-align': item.position}">
                <div class="misc">
                  <h1 class="banner-title f48">{{item.title}}</h1>
                  <h2 class="banner-subtitle f36" v-if="item.smalltitle">{{item.smalltitle.replace(/@/g, ' ')}}</h2>
                  <div class="banner-divider dib" v-if="item.smalltitle"></div>
                  <div>
                    <p class="main-misc" v-html="item.content.replace(/@/g, '<br/>')"></p>
                  </div>
                </div>
                <div class="banner-buttom" v-if="item.i_button === '1'">
                  <el-button v-if="item.videoButtonShow"
                             :class="`banner-button ${item.position==='center'?'banner-button-center':''}`"
                             @click="bannerClick('shouye-banner-tiyan')">申请体验
                  </el-button>
                  <el-button v-if="item.link&&!item.videoButtonShow" @click.prevent="gotoLink(item.link)"
                             :class="`banner-button ${item.position==='center'?'banner-button-center':''}`">
                    {{item.title&&item.position==='center'?item.title:'了解详情'}}
                  </el-button>
                  <el-button v-if="item.videoButtonShow"
                             :class="`banner-button video-button ${item.position==='center'?'banner-button-center':''}`"
                             @click="openVideoPlayer(videoCon)">
                    视频介绍
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="srm-section1">
      <div class="section1-item">
        <span>600+</span>
        <span>标杆企业</span>
      </div>
      <div class="section1-item">
        <span>30+</span>
        <span>行业应用</span>
      </div>
      <div class="section1-item">
        <span>20W+</span>
        <span>供应商</span>
      </div>
      <div class="section1-item">
        <span>1.6万亿</span>
        <span>采购交易额</span>
      </div>
    </div>
    <div class="srm-describe">
      <div class="tc w1200">
        <h1 class="title">{{indexTitle[0].name || 'undefined'}}</h1>
        <p class="content-word" v-html="describeContent.replace('@', '</br>')"></p>
        <div class="content">
          <div class="content-item" v-for="item in srmList" :key="item.code">
            <img :src="item.imgUrl" :alt="item.title">
            <h2>{{item.title}}</h2>
            <p>{{item.content}}</p>
            <div class="item-bottom">
              <a :href="item.hrefUrl" target="_blank">
                <span class="go-detail">了解详情 ></span>
              </a>
              <el-button class="banner-button" @click="bannerClick(item.code)">申请体验</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="srm-purchase" v-if="purchaseCon[0] !== undefined">
      <div class="w1200 purchase-box">
        <div class="srm-purchase-top">
          <h1>{{indexTitle[1].name || 'undefined'}}</h1>
          <p>从真实应用场景出发，解决企业采购管理应用痛点</p>
        </div>
        <div class="srm-purchase-tab w1200">
          <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="preventSwitch">
            <el-tab-pane :name="item.name" v-for="(item,index) in purchaseTabList" :key="index">
              <div slot="label" @mouseenter="activeName = item.name">{{item.title}}</div>
              <div class="srm-purchase-content">
                <div class="left">
                  <img :src="item.imgUrl" :alt="item.title">
                </div>
                <div class="right">
                  <h2>{{item.contentTitle}}</h2>
                  <ul>
                    <template v-for="value in item.contentList">
                      <li>{{value}}</li>
                    </template>
                  </ul>
                  <el-button class="right-button" @click="bannerClick(item.code,item.name)">获取方案详情</el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="更多产业" name="more"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="srm-advantage">
      <div class="clearfix advantage-box">
        <div class="clearfix tc">
          <h1 class="title">{{indexTitle[2].name || 'undefined'}}</h1>
          <p>采用创新技术，立足采购当下，助力企业采购数字化转型</p>
        </div>
        <div class="advantage-content">
          <div class="advantage-item" v-for="item in advantageList">
            <img :src="item.imgUrl" :alt="item.title">
            <h2>{{item.title}}</h2>
            <p>{{item.content}}</p>
            <ul>
              <template v-for="value in item.list">
                <li>{{value}}</li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="srm-clientele">
      <div class="clientele-box">
        <div class="tc">
          <h1 class="title">{{indexTitle[3].name || 'undefined'}}</h1>
          <p>打造采购管理服务口碑企业</p>
        </div>
        <div class="clientele-content">
          <div class="clientele-item" v-for="item in clienteleCon" :key="item.id">
            <img v-lazy="$global.globalPath + item.shouy_logo" :alt="item.title">
          </div>
        </div>
        <p class="more"><a href="/clientele" target="_blank">查看更多客户案例 ></a></p>
      </div>
    </div>

    <!--客户感言-->
    <div class="srm-client">
      <div class="w1200">
        <h1 class="title">{{indexTitle[4].name || 'undefined'}}</h1>
        <SpeechSwiper :mark="1"></SpeechSwiper>
      </div>
    </div>
    <!--新闻事件-->
    <div class="srm-journalism">
      <div class="journalism-box">
        <div class="tc">
          <h1 class="title">{{indexTitle[6].name || 'undefined'}}</h1>
          <h2>了解采购领域动态，紧跟采购管理趋势</h2>
        </div>
        <div class="clearfix journalism-con">
          <a class="fl journalism-con-left cp db" :href="getCompanyLink(newsDescrible.id,newsDescrible.cat_id)"
             target="_blank">
            <div class="journalism-left-img">
              <img v-lazy="$global.globalPath + newsDescrible.img" style="width:100%;height:100%"
                   :alt="newsDescrible.title">
            </div>
            <div class="journalism-left-span">
              <h1 class="journalism-title">{{newsDescrible.title}}</h1>
              <div>
                <p class="new-title">{{newsDescrible.origin}}</p>
                <p class="new-detail">查看详情 ></p>
              </div>
            </div>
          </a>
          <el-timeline :reverse="reverse" class="fl clearfix journalism-con-right cp db">
            <el-timeline-item
              v-for="(item, index) in newList" :key="index"
              :timestamp="item.year">
              <a :href="getCompanyLink(item.id,item.cat_id)" target="_blank">
                <span class="item-date">{{item.date}}</span>
                <h1 class="title">{{item.title}}</h1>
                <p class="descible">{{item.origin}}</p>
              </a>
            </el-timeline-item>
          </el-timeline>
          <a href="/company" target="_blank">
            <p class="look-more">查看更多 ></p>
          </a>
        </div>
      </div>
    </div>
    <!--联系我们-->
    <div class="rel clearfix srm-relation">
      <div class="srm-relation-content">
        <div class="left-img">
          <img src="../assets/img/index/form.svg" :alt="indexTitle[5].name">
        </div>
        <div class="right-content">
          <div v-if="!successRegister">
            <h1 class="content-title">{{indexTitle[5].name || 'undefined'}}</h1>
            <div class="srm-relation-form">
              <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" style="margin-top:25px"
                       class="demo-ruleForm">
                <el-form-item prop="name">
                  <el-input type="name" placeholder="请输入姓名"
                            :maxlength="20"
                            v-model="ruleForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="mobile">
                  <el-input v-model="ruleForm.mobile" :maxlength="11"
                            placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item prop="validate" class="validate-code">
                  <el-input :maxlength="4" placeholder="请输入验证码"
                            v-model="ruleForm.validate" class="form-input validate">
                  </el-input>
                  <img class="validate-img" @mousedown="disableDrag"
                       :src="validateUrl" alt="请求失败,请检查网络"/>
                  <span class="validate-span" @click="changeCode">看不清?换一张</span>
                </el-form-item>
                <el-form-item>
                  <el-button @click="submitForm('ruleForm')" :disabled="canSubmit"
                             class="form-button">立即提交
                  </el-button>
                  <el-button class="form-button" @click="goConsult">咨询客服</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div class="register-success" v-if="successRegister">
            <div class="success-title"><img src="../assets/img/register/icon_check.svg" alt="恭喜您，注册成功">
              <h1>恭喜您，注册成功！</h1>
            </div>
            <p>甄云顾问将会联系您并为您提供专业的讲解与演示</p>
          </div>
        </div>
      </div>
    </div>
    <!--视频弹窗-->
    <div class="index-video">
      <el-dialog
        custom-class="customClass"
        :visible.sync="centerDialogVisible"
        width="800px"
        @close="closeVideoDialog">
        <div class="video-test">
          <div class="video-img tc cp" v-show="showVideoImg" @click.stop.prevent="videoPlay">
            <div class="video-title dib">{{videoText}}</div>
          </div>
          <div class="homeDialog-video" @click.stop.prevent="videoClick">
            <video :src="videoPlayData" id="homeVideo"
                   @seeked="videoSeek" @pause="videoClick"
                   @error="videoError" @ended="videoDown"
                   preload="auto" controls autoplay controlsList="nodownload">
            </video>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import hoverButton from './common/hoverButton.vue'
import banner from './common/banner.vue'
import SpeechSwiper from './common/speechSwiper.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  metaInfo () {
    return {
      title: this.$seo.index.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.index.keywords
      },
      {
        name: 'description',
        content: this.$seo.index.description
      }]
    }
  },
  data () {
    var nameValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'))
      }
      callback()
    }
    var mobileValidate = (rule, value, callback) => {
      var isMob = /^[1]([3-9])[0-9]{9}$/ // 手机号码
      if (!value) {
        return callback(new Error('联系方式不能为空'))
      }
      if (isMob.test(value)) {
        callback()
      } else {
        callback(new Error('联系方式格式错误'))
      }
    }
    var codeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      }
      callback()
    }
    var codeValidate2 = (rule, value, callback) => {
      this.$api.post('/base/verifycode', { code: value }, (r) => {
        if (r.code === 0) {
          callback()
        } else {
          this.changeCode()
          callback(new Error('验证码错误！'))
        }
      })
    }
    return {
      reverse: true,
      activities: [{
        content: '活动按期开始',
        timestamp: '2018-04-15'
      }, {
        content: '通过审核',
        timestamp: '2018-04-13'
      }, {
        content: '创建成功',
        timestamp: '2018-04-11'
      }],
      carouselDia: false,
      videoText: '点击开始播放',
      dialogVisible: false,
      showVideoImg: true,
      loading: true,
      centerDialogVisible: false,
      indexTitle: this.$store.state.indexTitle || [],
      describeCon: this.$store.state.describeData[0] || [],
      describeContent: this.$store.state.describeData[0].content || '',
      introCon: [],
      purchaseCon: this.$store.state.purchaseCon || [],
      advantageCon: this.$store.state.advantageCon.right || [],
      advantageDesc: this.$store.state.advantageCon.left.content.split('@') || '',
      advantageTitle: this.$store.state.advantageCon.left.smalltitle.split('@') || '',
      advantageImg: this.$store.state.advantageCon.left.imgtag || '',
      testimonialsCon: [],
      bannerCon: [],
      solutionCon: [],
      clienteleCon: [],
      newsDescrible: this.$store.state.journalismConData.left || {},
      newList: this.$store.state.journalismConData.right || [],
      videoCon: {},
      videoPlayData: {},
      purchaseId: 1,
      advantageId: this.$store.state.advantageCon.right[0].id || 1,
      arrData: [1, 2, 3, 4, 5, 6, 7, 8],
      input: '',
      canSubmit: false,
      validateUrl: this.$global.globalPath + 'api/document/getcode',
      ruleForm: {
        code: 'shouye-zhuce',
        name: '',
        mobile: '',
        validate: '',
        registerpage: '首页',
        company: ''
      },
      rules: {
        name: [
          { validator: nameValidate, trigger: 'blur', required: true }
        ],
        mobile: [
          { validator: mobileValidate, trigger: 'blur', required: true }
        ],
        validate: [
          { validator: codeValidate, trigger: 'blur', required: true },
          { validator: codeValidate2, trigger: 'submit' }
        ]
      },
      srmList: [
        {
          code: 'shouye-chanpin-gongyingshang',
          imgUrl: require('../assets/img/index/icon_supplier.svg'),
          title: '供应商管理',
          content: '实现企业对供应商信息、绩效、风险、情报的全面掌握，360度洞察供应商',
          hrefUrl: '/supplier'
        },
        {
          code: 'shouye-chanpin-caigouxunyuan',
          imgUrl: require('../assets/img/index/icon_purchasemanage.svg'),
          title: '电子化采购寻源',
          content: '串联电商平台及自有供应商、通过询报价、比价多种方式，从采购需求端驱动企业降本',
          hrefUrl: '/purchasemanage'
        },
        {
          code: 'shouye-chanpin-zhaotoubiao',
          imgUrl: require('../assets/img/index/icon_bidding.svg'),
          title: '电子化招投标',
          content: '超越传统招投标，支持灵活选择竞价，询价模式，专家评审，优化企业招投标过程',
          hrefUrl: '/bidding'
        },
        {
          code: 'shouye-chanpin-neiwaixietong',
          imgUrl: require('../assets/img/index/icon_purchasecoordination.svg'),
          title: '采购内外协同',
          content: '配合微信及移动端的审批，消息提醒功能，提升企业采购效率，缩短采购周期',
          hrefUrl: '/purchasecoordination'
        },
        {
          code: 'shouye-chanpin-caigoushangcheng',
          imgUrl: require('../assets/img/index/icon_purchase.svg'),
          title: '非生物资采购商城',
          content: '直连京东、工品汇、苏宁易购等知名平台，低价优质，非生物资采购与管理融为一体',
          hrefUrl: '/ecdeal'
        },
        {
          code: 'shouye-chanpin-srm',
          imgUrl: require('../assets/img/index/icon_srmcloud.svg'),
          title: '甄采云',
          content: '海量供应商池，轻松对接ERP等系统，云端部署，短周期，让你快速实现采购数字化',
          hrefUrl: '/srmcloud'
        }
      ],
      activeName: 'dichan',
      purchaseTabList: [
        {
          code: 'shouye-jiejuefangan-kuaixiao',
          title: '快消行业',
          name: 'kuaixiao',
          imgUrl: require('../assets/img/index/kuaixiao.jpg'),
          contentTitle: '轻松应对快消行业采购多样性，紧急性，多供应商并存的需求',
          contentList: ['供应商全盘管理', '交期准确，减少库存量', '快速响应订单变更', '平衡寄售、OEM']
        },
        {
          code: 'shouye-jiejuefangan-jiadian',
          title: '家电行业',
          name: 'jiadian',
          imgUrl: require('../assets/img/index/jiadian.jpg'),
          contentTitle: '建立家电供应商协同管理平台，实现数据、流程、管理在线',
          contentList: ['多品类管控', '小批量、样品引入', '成本联动市场行情', '预测、VMI协同']
        },
        {
          code: 'shouye-jiejuefangan-zhuangbei',
          title: '装备制造',
          name: 'zhuangbei',
          imgUrl: require('../assets/img/index/zhuangbei.jpg'),
          contentTitle: '针对装备制造建立供应商管理、优化生产库存、全程可控',
          contentList: ['汇集各类采购需求', '降低库存占有率', '建立供应商绩效模型', '平衡寄售、OEM、外协库存']
        },
        {
          code: 'shouye-jiejuefangan-dichan',
          title: '地产行业',
          name: 'dichan',
          imgUrl: require('../assets/img/index/dichan.jpg'),
          contentTitle: '真正实现地产行业采购集中管控 精细化管理',
          contentList: ['工程招标透明', '工程量清单管理', '征信管理', '实现项目管控']
        },
        {
          code: 'shouye-jiejuefangan-canyin',
          title: '餐饮行业',
          name: 'canyin',
          imgUrl: require('../assets/img/index/canyin.jpg'),
          contentTitle: '缩短餐饮业供应链，减去中间环节，降低采购成本',
          contentList: ['物料主数据汇集', '供应商开发管理', '直连供应货源', '采购合同管理']
        },
        {
          code: 'shouye-jiejuefangan-zhengcheqipei',
          title: '整车汽配',
          name: 'zhengcheqipei',
          imgUrl: require('../assets/img/index/zhengcheqipei.png'),
          contentTitle: '管控各类汽配零部件，加强供应商深度参与',
          contentList: ['产品质量先期规划-APQP', '8D管理', '准时化生产JIT协同']
        }, {
          code: 'shouye-jiejuefangan-yiyao',
          title: '医药行业',
          name: 'yiyao',
          imgUrl: require('../assets/img/index/yiyao.jpg'),
          contentTitle: '实现医药行业采购流向追溯，做到全程合规、安全、透明',
          contentList: ['流向追溯', 'GSP/GMP', '返利管理', '供应商协同']
        },
        {
          code: 'shouye-jiejuefangan-guangfu',
          title: '光伏行业',
          name: 'guangfu',
          imgUrl: require('../assets/img/index/guangfu.jpg'),
          contentTitle: '从源头管控,实现光伏行业采购全流程的可查可追溯',
          contentList: ['合理计划采购', '送货排程', '物料认证', '物资消耗记录']
        }
      ],
      advantageList: [
        {
          imgUrl: require('../assets/img/index/icon_lead.svg'),
          title: '创新',
          content: '拥有国内创新技术，较大客户群，年投近亿元费用进行技术研发，让企业采购更简单、更高效',
          list: ['基于HZero融合中台的微服务开发架构', '松耦合结构，开发效率高、迭代速度快', '服务器层、存储层多层防护', '1000+功能配置，≥90%客户化无需二开']
        },
        {
          imgUrl: require('../assets/img/index/icon_ripe.svg'),
          title: '成熟',
          content: '已广泛应用于26+行业，让您未用已适用，提供行业标杆案例，帮您梳理采购管理全流程',
          list: ['05年研发，第四代已上线', 'SaaS+本地部署，灵活配置功能', '适用生产&非生物资采购管理', '26+行业真实应用，直接上线']
        },
        {
          imgUrl: require('../assets/img/index/icon_extend.svg'),
          title: '扩展',
          content: '产品开放接口，对接多方供应及企业内部系统，满足功能不断升级迭代，让您无后顾之忧',
          list: ['对接企业ERP等系统', '对接各大电商及供应资源', '对接第三方应用，一站式管理采购', '支持迭代，满足企业各阶段需求']
        }
      ],
      successRegister: false
    }
  },
  methods: {
    gotoLink (link) {
      window.open(link, '_blank')
    },
    goBannerLink (link, isButton) {
      if (isButton === '0') {
        window.open(link, '_blank')
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'more' && event.type === 'click') {
        let routeObj = this.$router.resolve({ name: 'Industry' })
        window.open(routeObj.href, '_blank')
      }
    },
    preventSwitch (tab) {
      if (tab === 'more') {
        return false
      }
    },
    goRouter (url) {
      if (url.length > 0) {
        window.open(url, '_blank')
      }
    },
    showIntroduction (item) {
      if (item.length > 32) {
        return item.slice(0, 32) + '...'
      } else {
        return item
      }
    },
    videoSeek () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.played) {
        this.showVideoImg = false
      }
    },
    videoClick () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.played) {
        this.videoText = '点击继续播放'
        videoDom.pause()
        this.showVideoImg = true
      } else {
        videoDom.play()
        this.showVideoImg = false
      }
    },
    videoPlay () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.paused) {
        videoDom.play()
        this.showVideoImg = false
      } else {
        videoDom.pause()
        this.showVideoImg = true
      }
    },
    videoDown () {
      this.videoText = '点击开始播放'
      this.showVideoImg = true
    },
    videoError () {
      this.videoText = '视频文件加载错误'
    },
    openVideoPlayer (data) {
      this.videoPlayData = {}
      this.centerDialogVisible = true
      this.showVideoImg = false
      this.videoPlayData = data
      this.$nextTick(() => {
        let videoDom = document.getElementById('homeVideo')
        videoDom.disablePictureInPicture = true
        videoDom.play()
      })
    },
    closeVideoDialog () {
      let videoDom = document.getElementById('homeVideo')
      this.videoText = '点击开始播放'
      this.showVideoImg = false
      videoDom.load()
      videoDom.pause()
    },
    bannerClick (code, currentCode) {
      this.openRegister(false, code, currentCode)
    },
    checkAdvantage (val) {
      this.advantageId = val
    },
    purchaseEnter (id) {
      this.purchaseId = id
    },
    // 获取bannerCon
    getBannerDate () {
      let a = { webname: 'index' }
      this.bannerCon = []
      let centerList = []
      let leftList = []
      this.$api.post('/banner/find_banner', a, (r) => {
        if (r.code === 0) {
          r.data.forEach(item => {
            item.videoButtonShow = false
            if (item.position === 'center') {
              centerList.push(item)
            } else {
              leftList.push(item)
            }
          })
          leftList[0].videoButtonShow = true
          this.bannerCon = centerList.concat(leftList)
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取VideoCon
    getVideoDate () {
      this.$api.post('/index/home_video', '', (r) => {
        if (r.code === 0) {
          this.videoCon = r.data.video_link
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面大标题
    getHeadlineDate () {
      this.$api.post('/index/home_headline', '', (r) => {
        if (r.code === 0) {
          this.indexTitle = r.data
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面describe内容
    getDescribeData () {
      this.describeCon = []
      this.$api.post('/index/home_what_is_srm', '', (r) => {
        if (r.code === 0) {
          this.describeCon = r.data[0]
          this.describeContent = r.data[0].content
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面purchase内容
    getPurchaseData () {
      this.purchaseCon = []
      this.$api.post('/index/home_category', '', (r) => {
        if (r.code === 0) {
          this.purchaseCon = r.data
          this.purchaseCon[1].content = r.data[1].content.split('@')
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面purchase内容
    getAdvantageData () {
      this.$api.post('/index/home_why', '', (r) => {
        if (r.code === 0) {
          this.advantageCon = r.data.right
          this.advantageDesc = r.data.left.content.split('@')
          this.advantageTitle = r.data.left.smalltitle.split('@')
          this.advantageImg = r.data.left.imgtag
          this.advantageId = this.advantageCon[0].id
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面clientele内容
    getclienteleData () {
      let a = {
        webname: 'index',
        cases_sum: ''
      }
      this.$api.post('/cases/get_cases', a, (r) => {
        if (r.code === 0) {
          this.clienteleCon = r.data
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面testimonials内容
    getTestimonialsData () {
      this.testimonialsCon = []
      let a = {
        mark: 1
      }
      this.$api.post('/index/home_speech', a, (r) => {
        if (r.code === 0) {
          this.testimonialsCon = r.data
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取页面journalismCon内容
    getjournalismConData () {
      this.$api.post('/index/home_news', {}, (r) => {
        if (r.code === 0) {
          this.newsDescrible = r.data.left
          this.newList = r.data.right
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.post('/base/register', this.ruleForm, (r) => {
            if (r.code === 0) {
              this.loading = true
              this.canSubmit = false
              this.successRegister = true
              this.$message({
                message: r.msg || '注册成功',
                type: 'success',
                duration: 2000
              })
              this.$refs[formName].resetFields()
              this.changeCode()
            } else {
              this.$message.error(r.message || r.data)
              this.$refs[formName].resetFields()
              this.changeCode()
            }
          })
        }
      })
    },
    changeCode () {
      let a = this.validateUrl
      this.validateUrl = ''
      this.$nextTick(() => {
        this.validateUrl = a
      })
    },
    disableDrag (event) {
      event.preventDefault()
    },
    goBusiness (url) {
      this.$router.push(url)
    },
    getBusinessLink (url) {
      let routeUrl = this.$router.resolve(url)
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    goClientele (item) {
      if (item.status === '0') {
        this.$router.push({
          name: 'ClienteleDetile',
          query: {
            id: item.id
          }
        })
      } else if (item.status === '1') {
        this.$api.post('/cases/twenty_four_hour', '', (r) => {
          if (r.code === 0) {
            if (r.data === 1) {
              this.$router.push({
                name: 'ClienteleDetile',
                query: {
                  id: item.id
                }
              })
            } else {
              this.openRegister(false, 2)
            }
          } else {
            this.$message.error(r.message)
          }
        })
      } else {

      }
    },
    getClientLink (item) {
      let routeUrl = this.$router.resolve({
        name: 'ClienteleDetile',
        query: {
          id: item.id
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    getCompanyLink (id, catId) {
      let routeUrl = this.$router.resolve({
        name: 'CompanyDetail',
        query: {
          id: id,
          cat_id: catId
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    goCompany (id, catId) {
      this.$router.push({
        name: 'CompanyDetail',
        query: {
          id: id,
          cat_id: catId,
          IsGoRoute: 'true'
        }
      })
    },
    GoAdvantage () {
      this.$router.push({
        name: 'Industry'
      })
    }
  },
  created () {
    this.loading = false
  },
  mounted () {
    this.newList = this.newList.filter((item, index) => {
      return index < 3
    })

    if (!this.indexTitle.length) {
      this.getHeadlineDate()
    }
    if (!Object.keys(this.describeCon).length) {
      this.getDescribeData()
    }
    //    this.getPurchaseData()
    //    this.getAdvantageData()
    this.getTestimonialsData()
    if (!this.newList.length) {
      this.getjournalismConData()
    }
    this.getBannerDate()
    this.getclienteleData()
    this.getVideoDate()
  },
  activated () {
  },
  computed: {
    // IsHover () {
    //   return this.advantageId === 1
    // }
  },
  components: {
    hoverButton,
    banner,
    SpeechSwiper
  }
}
</script>
<style lang="scss">
  @import "../../static/css/index.scss";

  .section1-item {

    &:first-child {
      margin-left: 0;
      background: url("../assets/img/index/bg_sign.svg") no-repeat;
    }

    &:nth-child(2) {
      background: url("../assets/img/index/bg_adhibition.svg") no-repeat;
    }

    &:nth-child(3) {
      background: url("../assets/img/index/bg_supplier.svg") no-repeat;
    }

    &:nth-child(4) {
      background: url("../assets/img/index/bg_purchase.svg") no-repeat;
    }
  }

</style>



// WEBPACK FOOTER //
// index.vue?78184e69